import { useDevolution } from '@hooks/DevolutionsContext';
import { devolutionColumns } from '@pages/DevolutionPage/components/DevolutionColumns/DevolutionColumns';
import { Table } from 'antd';
import React, { useEffect } from 'react';

const InDevolution: React.FC = () => {
  const {
    inDevolutionDevolutions,
    loadInDevolutionDevolutions,
    loadingDevolutions,
    inDevolutionFilters,
    inDevolutionPage,
    inDevolutionTotal,
  } = useDevolution();

  React.useEffect(() => {
    loadInDevolutionDevolutions(0);
  }, []);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      inDevolutionFilters.field = `${sorter.field}`;
      inDevolutionFilters.order = `${sorter.order}`;
    }

    loadInDevolutionDevolutions(pagination.current, inDevolutionFilters);
  };

  return (
    <Table
      columns={devolutionColumns}
      dataSource={inDevolutionDevolutions}
      loading={loadingDevolutions}
      pagination={{
        pageSize: 10,
        total: inDevolutionTotal,
        current: inDevolutionPage,
        showSizeChanger: false,
        showQuickJumper: false,
      }}
      scroll={{ x: 800 }}
      rowKey={(devolution) => devolution?.invoiceCode}
      onChange={handleTableChange}
    />
  );
};

export default InDevolution;
